export enum OverViewCards {
	GREETING_PHRASE = 'Greeting Phrase',
	AI_PROMPT = 'AI Prompt',
	CUSTOMIZE_VOICE_LANGUAGES = 'Customize Voice & Languages',
	SAMPLE_QUESTIONS_ANSWERS = 'Sample Questions & Answers',
	KNOWLEDGE_BASE = 'Knowledge Base',
	CALL_TRANSFERRING_WORKFLOW = 'Call Transferring Workflow',
	AI_MODEL_PREFERENCE = 'AI Model Preference',
	CALENDAR_SCHEDULING_WORKFLOW = 'Calendar Scheduling Workflow',
	TEXTING_WORKFLOW = 'Texting Workflow',
	EMAIL_WORKFLOW = 'Email Workflow',
	HANGUP_WORKFLOW = 'Hangup Workflow',
	PHONE_FORM_WORKFLOW = 'Phone Form Workflow',
	POST_CALL_WEBHOOK = 'Post Call Webhook',
	POST_CALL_MESSAGE = 'Post Call Message',
	TWEAK_ADVANCED_SETTINGS = 'Tweak Advanced Settings',
	API_WORKFLOW = 'API Workflow',
	TEXT_ASSIST = 'Text Assist',
	ZAPIER_INTEGRATION = 'Zapier Integration',
	CALL_RESPONSE_CONFIG = 'Call Response Config',
	SMART_CALL_ANALYSIS = 'Smart Call Analysis',
	CHOOSE_VOICE = 'Choose Voice',
}
